module.exports = __webpack_public_path__ + "static/media/1 17 gjerne.89a17b31.mp3";